import type { ReactNode } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ConstructionIcon from '@mui/icons-material/Construction';

import { useMaintenanceStatus } from '../hooks/useMaintenanceStatus';

/**
 * Non-dismissible modal afișat când maintenance e activă (B13).
 *
 * Polling 60s via `useMaintenanceStatus` hook. Când is_active=true, modal
 * preia toată ecranul + dezactivează interacțiunea cu app-ul.
 *
 * NU se folosește ESC sau backdrop click pentru a închide — user trebuie să
 * aștepte ca admin să dezactiveze maintenance.
 */
export function MaintenanceModal(): ReactNode {
  const status = useMaintenanceStatus();

  if (!status.isActive) {
    return null;
  }

  return (
    <Dialog
      open
      fullScreen
      disableEscapeKeyDown
      aria-labelledby="maintenance-title"
    >
      <DialogTitle id="maintenance-title">
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <ConstructionIcon color="warning" sx={{ fontSize: 40 }} />
          <Typography variant="h4">Mentenanță programată</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', minHeight: '50vh', gap: 3, p: 4 }}>
          <Typography variant="body1" align="center" sx={{ maxWidth: 600 }}>
            {status.message ?? 'Aplicația este în mentenanță. Vă rugăm reveniți în câteva minute.'}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Această pagină se va actualiza automat la fiecare 60 de secunde.
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
